import React from 'react';
import { trackInitiateCheckout } from '../lib/pixel';
export function Hero() {
  return <section className="bg-hero-gradient text-center pt-[60px] pb-[50px] px-5 border-b border-divider" data-id="element-83">
      <div className="text-[13px] tracking-[4px] text-gold font-bold mb-2 uppercase" data-id="element-84">
        <span className="text-gold text-xl mx-1.5" data-id="element-85">✝</span> MISIÓN INFLUENCIA™{' '}
        <span className="text-gold text-xl mx-1.5" data-id="element-86">✝</span>
      </div>

      <h1 className="text-2xl md:text-4xl lg:text-[42px] font-black leading-tight text-text-heading mb-5 max-w-[700px] mx-auto" data-id="element-87">
        ¿Tenés fe pero no sabés cómo compartirla sin sonar{' '}
        <span className="text-gold" data-id="element-88">predicador, invasivo o raro?</span>
      </h1>

      <p className="text-[15px] md:text-lg text-text-muted max-w-[580px] mx-auto mb-8 leading-relaxed" data-id="element-89">
        El sistema completo para que el cristiano moderno evangelice en
        Instagram de forma natural, estratégica y con impacto real. Sin miedo al
        rechazo. Sin perder seguidores.
      </p>

      {/* Hero product image */}
      <div className="relative max-w-[820px] mx-auto mb-10 px-2" data-id="element-90">
        {/* Soft gold glow behind the image */}
        <div aria-hidden="true" className="absolute inset-0 -z-10 blur-3xl opacity-40 bg-[radial-gradient(ellipse_at_center,_rgba(201,168,76,0.5)_0%,_transparent_65%)]" data-id="element-91" />
        <img src="https://cdn.magicpatterns.com/uploads/jtaBajFCxfUZuNria5hFwx/imagen_mi2.png" alt="Misión Influencia — Megapack: 6 Tomos digitales y 5 Bonos para cristianos en Instagram" loading="eager" className="w-full h-auto rounded-2xl border border-gold/30 shadow-[0_20px_60px_-15px_rgba(201,168,76,0.35),0_0_0_1px_rgba(201,168,76,0.1)]" data-id="element-92" />
        {/* Subtle dark vignette overlay edges to blend with background */}
        <div aria-hidden="true" className="pointer-events-none absolute inset-0 rounded-2xl bg-[radial-gradient(ellipse_at_center,_transparent_55%,_rgba(10,10,10,0.5)_100%)]" data-id="element-93" />
      </div>

      <div className="flex flex-wrap justify-center gap-2.5 mb-[30px]" data-id="element-94">
        <span className="bg-[#1a1a2e] border border-gold text-gold py-1.5 px-3.5 rounded-full text-xs font-semibold" data-id="element-95">
          ✝️ 100% PDF
        </span>
        <span className="bg-[#1a1a2e] border border-gold text-gold py-1.5 px-3.5 rounded-full text-xs font-semibold" data-id="element-96">
          ⚡ Acceso en 5 min
        </span>
        <span className="bg-[#1a1a2e] border border-gold text-gold py-1.5 px-3.5 rounded-full text-xs font-semibold" data-id="element-97">
          🇦🇷 Para cristianos argentinos
        </span>
        <span className="bg-[#1a1a2e] border border-gold text-gold py-1.5 px-3.5 rounded-full text-xs font-semibold" data-id="element-98">
          📚 6 Tomos + 5 Bonos
        </span>
      </div>

      <a href="https://www.stockdigital.shop/checkouts/cn/hWNCSin712GXjdX6ppEUlcMk/es-ar?_r=AQABm5guWdJPztfbKHa5RgQhBMMz6LhQ32Hjk18aTGNwW0U&cart_link_id=hFwtJKea&preview_theme_id=140123340859" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout('esencial')} className="inline-block bg-gold-gradient text-base font-black text-[17px] py-[18px] px-9 rounded-full no-underline mb-4 shadow-[0_4px_20px_rgba(201,168,76,0.4)] transition-transform duration-200 hover:scale-[1.03]" data-id="element-99">
        🔥 QUIERO MI MISIÓN INFLUENCIA AHORA
      </a>

      <div className="text-xs text-[#888] mb-6 flex justify-center flex-wrap gap-4" data-id="element-100">
        <span data-id="element-101">✅ Garantía 7 días</span>
        <span data-id="element-102">🔒 Pago seguro</span>
        <span data-id="element-103">💳 Mercado Pago</span>
      </div>

      <div className="flex flex-wrap justify-center gap-4 text-[13px] text-gold font-bold" data-id="element-104">
        <span data-id="element-105">+800 cristianos</span>
        <span data-id="element-106">·</span>
        <span data-id="element-107">6 Tomos</span>
        <span data-id="element-108">·</span>
        <span data-id="element-109">5 Bonos</span>
        <span data-id="element-110">·</span>
        <span data-id="element-111">⭐ 4.9/5</span>
      </div>
    </section>;
}